
  console.log('Quinn handler loaded');
    try {
        Quinn.functions.renderQuinnWidgets();
      } 
      catch (error) {
        console.error("Quinn app error ==> ", error);
  
        setTimeout(() => {
          try {
            Quinn.functions.renderQuinnWidgets();
          } catch (error) {
            console.log("Quinn app error in debounce ==> ", error);
          }
        }, 2000);
  
      }
